/**
 * @name: 通知管理
 * @param {
 *  props: 创建编辑信息
 *  id：操作对象id
 *  emit
 * }
 * @return  创建，编辑，撤销，开始更新，更新完成
 */
import { ref, getCurrentInstance } from 'vue';
import { ElMessage } from 'element-plus';
import { INoticePageResListItem } from '@/api/content-manage/type.d';
import { IDictValuesItem, DICT_CODE_TYPE_LIST, OPERATION_TYPE_ENUM } from '../constant/index';
import {
  noticeCreate, // 创建通知
  noticeEdit, // 编辑通知
  noticeWithdraw, // 通知撤回
  noticeStartUpdate, // 开始更新通知
  noticeFinishUpdate, // 结束更新通知
  getSystemDictValues, // 获取字典
} from '@/api/content-manage/index';
import { formatTime } from '@toy/utils';

export const _CreatedNotice = (props = {} as any, emit = '' as any) => {
  const currentInstance = getCurrentInstance()!;
  const noticeItem = ref<INoticePageResListItem>({} as INoticePageResListItem);
  // 编辑
  const createdNoticeVisible = ref<boolean>(false);
  const dialogVisible = ref<boolean>(false);
  const detailVisible = ref<boolean>(false);
  const message = ref<string>('');
  const noticeCode = ref<string>('');
  const currentOperation = ref<string>(OPERATION_TYPE_ENUM.DEFAULT);
  // 获取字典返回值
  const dictValues = ref<IDictValuesItem[]>([]);
  const handleNoticeEdit = (row: INoticePageResListItem) => {
    noticeItem.value = {
      ...row,
    };
    createdNoticeVisible.value = true;
  };

  // 详情
  const handleNoticeDetail = (row: INoticePageResListItem) => {
    noticeItem.value = {
      ...row,
    };
    detailVisible.value = true;
  };
  // 创建
  const handleClose = () => {
    (currentInstance.refs.ruleForm as any).resetFields();
    emit('update:visible', false);
  };
  const handleIncreased = () => {
    noticeItem.value = {} as INoticePageResListItem;
    createdNoticeVisible.value = true;
  };
  const handleSave = async () => {
    await (currentInstance.refs.ruleForm as any).validate();
    const params = {
      ...props.value,
    };
    params.publishTime = formatTime(props.value.publishTime);
    params.publishEndTime = formatTime(props.value.publishEndTime);
    const currentTime = formatTime(new Date());
    if (currentTime > params.publishEndTime) {
      ElMessage.error('结束时间必须大于当前系统时间');
      return;
    }
    if (props.value.noticeId) {
      await noticeEdit(Object.assign({}, { noticeId: props.value.noticeId }, params));
    } else {
      await noticeCreate(params);
    }
    ElMessage.success('操作成功！');
    emit('handleSearch');
    handleClose();
  };

  // 获取字典
  const handleDictValues = async () => {
    if (dictValues.value.length > 0) return;
    const { data } = await getSystemDictValues(DICT_CODE_TYPE_LIST.DICT_CODE);
    dictValues.value = data[0]?.dictValues;
  };

  // 撤销
  const handleUndo = (row: INoticePageResListItem, state: string) => {
    dialogVisible.value = true;
    currentOperation.value = state;
    noticeCode.value = row.noticeCode as string;
    message.value = `确认撤销<strong>[${row.noticeCode}]</strong>通知？`;
  };

  // 开始更新
  const handleStart = (row: INoticePageResListItem, state: string) => {
    dialogVisible.value = true;
    currentOperation.value = state;
    noticeCode.value = row.noticeCode as string;
    message.value = `确认<strong>[${row.updateSystem.join()}]</strong>开始更新？\n
    根据您的设置<strong>[${row.noticeSystem.join()}]</strong>将不可操作`;
  };

  // 更新完成
  const handleComplete = (row: INoticePageResListItem, state: string) => {
    dialogVisible.value = true;
    currentOperation.value = state;
    noticeCode.value = row.noticeCode as string;
    message.value = `确认<strong>[${row.updateSystem.join()}]</strong>更新完成？
    根据您的设置<strong>[${row.noticeSystem.join()}]</strong>将恢复正常使用`;
  };
  const handleOperationCallBack = async (searchCb: any) => {
    if (currentOperation.value === OPERATION_TYPE_ENUM.FINISHED) {
      await noticeFinishUpdate(noticeCode.value);
    } else if (currentOperation.value === OPERATION_TYPE_ENUM.UPDATE) {
      await noticeStartUpdate(noticeCode.value);
    } else if (currentOperation.value === OPERATION_TYPE_ENUM.WITHDRAW) {
      await noticeWithdraw(noticeCode.value);
    }
    dialogVisible.value = false;
    ElMessage.success('操作成功！');
    setTimeout(() => {
      searchCb();
    }, 1000);
  };
  return {
    // 新增
    createdNoticeVisible,
    detailVisible,
    dictValues,
    handleIncreased,
    handleSave,
    handleClose,

    // 编辑
    handleNoticeEdit,

    // 详情
    handleNoticeDetail,

    // 开始更新
    handleStart,

    // 撤销
    handleUndo,

    // 更新完成
    handleComplete,

    noticeItem,

    // 获取字典
    handleDictValues,
    message,
    dialogVisible,
    handleOperationCallBack,
  };
};
